import AddCompany from "../../components/admin/add-company"


const AddCompanyPage = () => {
    return <AddCompany/>
}

export default AddCompanyPage;